module.exports = __webpack_public_path__ + "img/edition_3.594b1540.png";